import { HandQueueGameControlButton } from './components/HandQueueGameControlButton/HandQueueGameControlButton';
import { Wrapper } from './GameControlHeader.styled';

export const GameControlHeader = () => {
  return (
    <Wrapper>
      <HandQueueGameControlButton />
    </Wrapper>
  );
};
